import LoginLayout from "@/src/components/LoginPage/LoginLayout";

const LoginPage = () => {
  return <LoginLayout />;
};

export default LoginPage;
